import React from 'react'
import Header from './Header'
import Footer from './Footer'

const index = ({ children }) => {
  return (
    <React.Fragment>
      <Header />
      <main className='content'>{children}</main>
      <Footer />
    </React.Fragment>
  )
}

export default index
